import React from "react";
import { Pencil, Trash2, UserPlus } from "lucide-react";
import Avatar from "./Avatar";
import CLevelAssign from "./CLevelAssign";
import CollaboratorBadges from "./CollaboratorBadges";

export default function PersonRow({ person, isAdmin, onEdit, onDelete, cSuiteNodes, onView, allPeople }) {
  const isVacancy = person.is_vacancy;
  return (
    <div
      className={`flex items-center gap-2 py-1.5 px-2 -mx-2 rounded-lg group transition-colors duration-200 ${isVacancy ? "border border-dashed border-gray-300 bg-gray-50/50" : "hover:bg-gray-50"}`}
      onClick={() => !isAdmin && onView?.(person)}
      style={!isAdmin ? { cursor: "pointer" } : {}}
    >
      {isVacancy ? (
        <div className="w-8 h-8 rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center bg-gray-50 flex-shrink-0">
          <UserPlus className="w-3.5 h-3.5 text-gray-400" />
        </div>
      ) : (
        <Avatar name={person.name} photoUrl={person.photo_url} size="sm" />
      )}
      <div className="flex-1 min-w-0 flex items-center gap-1.5">
        <div className="min-w-0">
          <p className={`text-sm font-medium leading-tight truncate ${isVacancy ? "italic text-gray-400" : "text-gray-900"}`}>
            {isVacancy ? "Open Position" : person.name}
          </p>
          <p className="text-xs leading-tight truncate text-gray-500">
            {`${person.function_area || ""}${person.seniority ? ` (${person.seniority})` : ""}`}
          </p>
        </div>
        <CollaboratorBadges collaboratorIds={person.collaborators} allPeople={allPeople} />
      </div>
      <CLevelAssign
        cSuiteNodes={cSuiteNodes}
        assignedCLevelId={person.c_level_id}
        isAdmin={false}
      />
      {isAdmin && (
        <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => onEdit(person)}
            title="Edit Person"
            className="p-1 text-gray-400 hover:text-blue-600"
          >
            <Pencil className="w-3.5 h-3.5" />
          </button>
          <button
            onClick={() => onDelete(person.id)}
            title="Delete Person"
            className="p-1 text-gray-400 hover:text-red-600"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        </div>
      )}
    </div>
  );
}